module.exports = __webpack_public_path__ + "static/media/dyzma1.00870a8c.jpg";